import React from 'react';
import { Grid, Box, Typography, Button } from '@quillbot/design-system';

interface IProps {
  classes: Record<string, string>;
}

function AffiliateButton(props: IProps) {
  return (
    <Box boxShadow={0} style={{ width: '100%' }}>
      <Grid container>
        <Grid item xs={12} className="qbp-textCenter">
          <Button
            className={`${props.classes.affiliateButton} no-box-shadow`}
            color="primary"
            variant="contained"
            onClick={() => {
              window.open('https://quillbot.partnerstack.com/', '_blank');
            }}
          >
            Become an Affiliate
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AffiliateButton;
